/* eslint-disable prefer-const */
import { getProperty, hasValue, isNullOrUndefined } from '../../../../../../general/js/general-helpers';
import { modalConstants } from '../../../../../modal/js/modal-constants';
import { toggleBemClassForWrapperModal } from '../../../../../modal/js/modal-helpers';
import { ssoFormTypes } from '../../../utils/form-types';

export const getModalContentClassListForSSOForm = (props = {}) => {
    const baseClassList = 'modal__content form-container form-container__full';

    if (!hasValue(props)) {
        return baseClassList;
    }

    const formData = getFormDataForSSOForm(props);

    if (!hasValue(formData)) {
        return baseClassList;
    }

    const { desktopImageSrc } = formData;

    return `${baseClassList} ${hasValue(desktopImageSrc) ? 'form-container__wide' : ''}`;
};

export const getFormContainerWideLeftClassList = (props = {}) => {
    const baseClassList = 'form-container__wide--left';

    if (!hasValue(props)) {
        return baseClassList;
    }

    const formData = getFormDataForSSOForm(props);

    const desktopImageSrc = getProperty(formData, 'desktopImageSrc');
    const mobileImageSrc = getProperty(formData, 'mobileImageSrc');

    return `${baseClassList} ${hasValue(desktopImageSrc) ? 'form-popup__header--no-bg-image-desktop' : ''} ${hasValue(mobileImageSrc) ? 'form-popup__header--no-bg-image-mobile' : ''}`;
};

export const toggleBemClassesForSSOFormModal = (formReference = null, props = {}, formType = -1) => {
    if (!hasValue(props) || isNullOrUndefined(formReference) || isNullOrUndefined(formReference.current)) {
        return false;
    }

    const { addBemList, removeBemList } = getBemClassesToToggle(props, formType);

    if (!hasValue(addBemList) && !hasValue(removeBemList)) {
        return false;
    }

    toggleBemClassForWrapperModal(formReference.current, addBemList, true);
    toggleBemClassForWrapperModal(formReference.current, removeBemList, false);

    return true;
};

const getBemClassesToToggle = (props = {}, formType = -1) => {
    const formData = getFormDataForSSOForm(props);

    if (!hasValue(formData)) {
        return {};
    }

    const desktopImageSrc = getProperty(formData, 'desktopImageSrc');
    let { addBemList, removeBemList } = getInitialBemClassesToToggle(formType);

    if (hasValue(desktopImageSrc)) {
        addBemList.push(modalConstants.MODAL_BEM_CLASS_WIDE);
        addBemList.push(modalConstants.MODAL_BEM_CLASS_SPLIT);
    } else {
        removeBemList = mergeBemList(removeBemList, getRemoveBemClasses(formType, desktopImageSrc));
    }

    return {
        addBemList,
        removeBemList
    };
};

const getInitialBemClassesToToggle = (formType = -1) => {
    switch (formType) {
        case ssoFormTypes.DefaultRegister:
        case ssoFormTypes.OneClubRegister:
        case ssoFormTypes.TicketingRegister:
            return {
                addBemList: [
                    modalConstants.MODAL_BEM_CLASS_MOBILE_FIXED,
                    modalConstants.MODAL_BEM_CLASS_AUTO
                ],
                removeBemList: []
            };
        case ssoFormTypes.UpgradeToOneClubAccountFromDefault:
        case ssoFormTypes.UpgradeToOneClubAccountFromTicketing:
        case ssoFormTypes.UpgradeToTicketingAccount:
            return {
                addBemList: [],
                removeBemList: [
                    modalConstants.MODAL_BEM_CLASS_AUTO]
            };
        case ssoFormTypes.SignIn:
        case ssoFormTypes.BallotSignInForm:
            return {
                addBemList: [
                    modalConstants.MODAL_BEM_CLASS_MOBILE_FIXED,
                    modalConstants.MODAL_BEM_CLASS_AUTO
                ],
                removeBemList: [
                    modalConstants.MODAL_BEM_CLASS_WIDE,
                    modalConstants.MODAL_BEM_CLASS_SPLIT
                ]
            };
        default:
            return {
                addBemList: [],
                removeBemList: []
            };
    }
};

const getRemoveBemClasses = (formType = -1, desktopImageSrc = '') => {
    switch (formType) {
        case ssoFormTypes.DefaultRegister:
        case ssoFormTypes.OneClubRegister:
        case ssoFormTypes.TicketingRegister:
        case ssoFormTypes.BallotLiteRegister:
        case ssoFormTypes.BallotFullRegister:
            if (hasValue(desktopImageSrc)) {
                return [
                    modalConstants.MODAL_BEM_CLASS_MOBILE_FIXED
                ];
            }

            return [
                modalConstants.MODAL_BEM_CLASS_SPLIT
            ];
        case ssoFormTypes.UpgradeToOneClubAccountFromDefault:
        case ssoFormTypes.UpgradeToOneClubAccountFromTicketing:
        case ssoFormTypes.UpgradeToTicketingAccount:
        case ssoFormTypes.BallotSummaryForm:
            return [
                modalConstants.MODAL_BEM_CLASS_AUTO
            ];
        default:
            return [];
    }
};

const mergeBemList = (initialBemList = [], bemListToMerge = []) => {
    const finalBemList = initialBemList;

    bemListToMerge.forEach((bemClass) => {
        if (!finalBemList.includes(bemClass)) {
            finalBemList.push(bemClass);
        }
    });

    return finalBemList;
};

const getFormDataForSSOForm = (props = {}) => {
    let formData = {};

    if (!hasValue(props)) {
        return formData;
    }

    const formDataObjects = [
        props.registerFormData,
        props.formData,
        props.signInFormData
    ];

    formDataObjects.every((formDataObject) => {
        if (hasValue(formDataObject)) {
            formData = formDataObject;
            return false;
        }

        return true;
    });

    return formData;
};
